import { Key, NgxIndexedDBService } from 'ngx-indexed-db';
import { of } from 'rxjs';
import { catchError, tap, switchMap } from 'rxjs/operators';
import { IDBKeyValue, IndexDb } from '../../IndexDb.interface';

export class IndexDbHandler implements IndexDb {
  storeName = '';
  /**
   *@param store  store name in indexed db
   */
  constructor(store: string, private dbService: NgxIndexedDBService) {
    this.storeName = store;
  }

  InvokeMethod(methodName: string, ...params: any) {
    if (typeof this[methodName] === 'function') {
      this[methodName](...params);
    }
  }

  addOrUpdate(key: IDBValidKey, value: any, callback: (result: any) => void) {
    const obs$ = this.dbService
      .getByKey(this.storeName, key)
      .pipe(
        switchMap((response) => {
          if (response != null) {
            return this.dbService.update(this.storeName, value);
          } else {
            return this.dbService.add(this.storeName, value, key);
          }
        }),
        tap((response) => {
          callback(response);
          obs$.unsubscribe();
        }),
        catchError((error) => {
          console.error(error);
          return of(error);
        })
      )
      .subscribe();
  }
  delete(key: Key, callback: (result: any) => void) {
    const obs$ = this.dbService
      .deleteByKey(this.storeName, key)
      .pipe(
        tap((response) => {
          callback(response);
          obs$.unsubscribe();
        }),
        catchError((error) => {
          console.error('Indexed-db', error);
          return of(error);
        })
      )
      .subscribe();
  }
  bulkDelete(keys: Key[], callback: (result: any) => void) {
    const obs$ = this.dbService
      .bulkDelete(this.storeName, keys)
      .pipe(
        tap((response) => {
          callback(response);
          obs$.unsubscribe();
        }),
        catchError((error) => {
          console.error('Indexed-db', error);
          return of(error);
        })
      )
      .subscribe();
  }
  getByKey(key: IDBValidKey, callback: (result: any) => void) {
    const obs$ = this.dbService
      .getByKey(this.storeName, key)
      .pipe(
        tap((response) => {
          callback(response);
          obs$.unsubscribe();
        }),
        catchError((error) => {
          console.error('Indexed-db', error);
          return of(error);
        })
      )
      .subscribe();
  }
  bulkGet(keys: IDBValidKey[], callback: (result: any) => void) {
    const obs$ = this.dbService
      .bulkGet(this.storeName, keys)
      .pipe(
        tap((response) => {
          callback(response);
          obs$.unsubscribe();
        }),
        catchError((error) => {
          console.error('Indexed-db', error);
          return of(error);
        })
      )
      .subscribe();
  }
  getAll(callback: (result: any) => void) {
    const obs$ = this.dbService
      .getAll(this.storeName)
      .pipe(
        tap((response) => {
          callback(response);
          obs$.unsubscribe();
        }),
        catchError((error) => {
          console.error('Indexed-db', error);
          return of(error);
        })
      )
      .subscribe();
  }
  getByIndex(
    columnName: string,
    key: IDBValidKey,
    callback: (result: any) => void
  ) {
    const obs$ = this.dbService
      .getByIndex(this.storeName, columnName, key)
      .pipe(
        tap((response) => {
          callback(response);
          obs$.unsubscribe();
        }),
        catchError((error) => {
          console.error('Indexed-db', error);
          return of(error);
        })
      )
      .subscribe();
  }
  update(value: any, callback: (result: any) => void) {
    const obs$ = this.dbService
      .update(this.storeName, value)
      .pipe(
        tap((response) => {
          callback(response);
          obs$.unsubscribe();
        }),
        catchError((error) => {
          console.error('Indexed-db', error);
          return of(error);
        })
      )
      .subscribe();
  }
  updateByKey(value: any, key: IDBValidKey, callback: (result: any) => void) {
    const obs$ = this.dbService
      .updateByKey(this.storeName, value, key)
      .pipe(
        tap((response) => {
          callback(response);
          obs$.unsubscribe();
        }),
        catchError((error) => {
          console.error('Indexed-db', error);
          return of(error);
        })
      )
      .subscribe();
  }
  count(callback: (result: any) => void) {
    const obs$ = this.dbService
      .count(this.storeName)
      .pipe(
        tap((response) => {
          callback(response);
          obs$.unsubscribe();
        }),
        catchError((error) => {
          console.error('Indexed-db', error);
          return of(error);
        })
      )
      .subscribe();
  }
  clear(callback: (result: any) => void) {
    const obs$ = this.dbService
      .clear(this.storeName)
      .pipe(
        tap((response) => {
          callback(response);
          obs$.unsubscribe();
        }),
        catchError((error) => {
          console.error('Indexed-db', error);
          return of(error);
        })
      )
      .subscribe();
  }
}
